import * as React from 'react';

export const RightTickGreenSvg = (props: any) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='100'
			height='100'
			fill='none'
			viewBox='0 0 100 100'
			{...props}
		>
			<circle cx='50' cy='50' r='50' fill='#DBFDDB'></circle>
			<path
				stroke='#088943'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='4'
				d='M67.5 36.389L43.437 61.667 32.5 50.177'
			></path>
		</svg>
	);
};
